import { BaseImageContainerStyles, BaseMainPanelContainer, BasePageTitleContainer, BaseTemplateStyles } from '../elements';
import { breakpoints, Size } from '../../../abstracts';
import { styled } from 'styled-components';
import { dontForwardProps, pxToRem } from '../../../util';
export const BaseMapTemplate = styled.div.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-ahv2z8-0"
})(["", ";grid-template-rows:auto auto 1fr;", ";@media (max-width:", "px){", "}", " ", "{padding-left:var(--aui-spacing-300);padding-right:var(--aui-spacing-300);", "}", "{height:calc(100vh - ", ");", " grid-template-columns:7fr 5fr;grid-template-rows:1fr;padding-left:var(--aui-spacing-600);padding-right:var(--aui-spacing-600);overflow-y:scroll;}", "{grid-template-rows:auto 1fr;margin-left:auto;margin-right:auto;}"], BaseTemplateStyles, props => props.hasButtonGroup ? props.progressStepper ? `
    grid-template-areas:
      'progress-stepper'
      'page-title'
      'image'
      'main-panel'
      'button-group';
      grid-template-rows: min-content max-content max-content auto min-content;
      ` : `
    grid-template-areas:
      'page-title'
      'image'
      'main-panel'
      'button-group';` : `
    grid-template-areas:
      'page-title'
      'image'
      'main-panel';
    `, Size.MD - 1, props => props.progressStepper && `margin-top: var(--aui-spacing-400);`, props => !props.hasButtonGroup && `
    @media (max-width: ${Size.MD2 - 1}px) {
      padding-bottom: var(--aui-spacing-600);
    }
  `, breakpoints.md, props => props.hasButtonGroup && props.progressStepper && `
        grid-template-areas: 
          'page-title'
          'image'
          'main-panel'
          'button-group';
        grid-template-rows: auto auto 1fr;
      `, breakpoints.md2, props => props.upperVerticalOffset, props => props.hasButtonGroup ? `
      grid-template-areas:
        'page-title image'
        'main-panel image'
        'button-group image';;
    ` : `grid-template-areas: 
            'page-title image'
            'main-panel image';
      `, breakpoints.md2);
export const PageTitleContainer = styled(BasePageTitleContainer).withConfig({
  componentId: "aui__sc-ahv2z8-1"
})(["grid-area:page-title;", "{margin-top:var(--aui-spacing-600);}", "{margin-right:var(--aui-spacing-300);}", "{margin-right:0;}"], breakpoints.md, breakpoints.md2, breakpoints.xl);
export const MainPanelContainer = styled(BaseMainPanelContainer).withConfig({
  componentId: "aui__sc-ahv2z8-2"
})(["", "{margin-right:var(--aui-spacing-300);padding-bottom:var(--aui-spacing-600);}", "{margin-right:0;}"], breakpoints.md2, breakpoints.xl);
export const MapContainer = styled.div.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-ahv2z8-3"
})(["", ";grid-area:image;height:", "rem;", "{height:", "rem;}", "{top:0;position:sticky;height:calc(100vh - ", ");margin-left:0;width:calc(100% + var(--aui-spacing-600));}", "{width:calc(100% - var(--aui-spacing-300));margin-left:var(--aui-spacing-300);}"], BaseImageContainerStyles, pxToRem(320), breakpoints.md, pxToRem(400), breakpoints.md2, props => props.upperVerticalOffset, breakpoints.xl);
export const Map = styled.img.withConfig({
  componentId: "aui__sc-ahv2z8-4"
})(["object-fit:cover;height:100%;width:100%;"]);